import React from 'react';
import EscoStatusGrid from '../../Controls/EscoStatusGrid/EscoStatusGrid';
import { color } from 'chart.js/helpers';

const columns = [
  { field: 'descripcion', headerName: 'Descripción', flex: 1 },
  { field: 'fechaInicio', headerName: 'Fecha de Inicio', flex: 1 },
  { field: 'fechaFin', headerName: 'Fecha de Fin', flex: 1 },
  { field: 'fechaError', headerName: 'Fecha de Error', flex: 1 },
  { field: 'mensaje', headerName: 'Mensaje', flex: 2 },
  { field: 'estado', headerName: 'Estado', flex: 0.5 }
];

const ActivityLog = ({ data }) => {
  return (
    <div className="activity-log">
      <p style={{color: 'gray', fontWeight: 'bold'}}>Registro de Actividades</p>
      <EscoStatusGrid columns={columns} data={data}  />
    </div>
  );
};


export default ActivityLog;
